import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

// 引入UI组件
import '@/plugins/element.js'

// 引入字体图标
import '@/assets/font-icon/iconfont.css'

// 引入语言
import {i18n, vantLocales} from './lang'

// 引入公共样式
import '@/assets/css/base.css'

// 引入amfe-flexible
import 'amfe-flexible'

// 引入剪切板插件
import VueClipBoard from 'vue-clipboard2'

// 区号选择插件
import VueCountryIntl from 'vue-country-intl';
// 引入css
import 'vue-country-intl/lib/vue-country-intl.css'
// 全局注册组件
Vue.component(VueCountryIntl.name, VueCountryIntl);

// 引入全局过滤器
import * as custom from '@/utils/filter.js'
// 注册全局过滤器
Object.keys(custom).forEach(key => {
    Vue.filter(key, custom[key])
})

// 注册语言
vantLocales(i18n.locale)

// 引入自定义指令
import '@/utils/directives.js'

// 引入moment
import moment from 'moment'

// 注册剪切板插件
Vue.use(VueClipBoard)

Vue.prototype.$moment = moment

// 注册全局导航守卫判断是否未登录
// 路由白名单
// const whiteList = ['/login'];
router.beforeEach((to, from, next) => {
    if (to.meta.subTitle) {
        // 标题
        document.title = to.meta.subTitle
        // ico图标
        let favicon = document.querySelector('link[rel="icon"]')
        if (favicon !== null) {
            // favicon.href = to.meta.subTitle === 'Laidan' ? '/favicon.ico' : '/favicon2.ico'
            if (to.meta.subTitle === 'Laidan') {
                favicon.href = '/favicon.ico'
            } else if (to.meta.subTitle === 'Joinku') {
                favicon.href = '/favicon2.ico'
            } else {
                favicon.href = '/favicon3.ico'
            }
        } else {
            favicon = document.createElement('link')
            favicon.rel = 'icon'
            // favicon.href = to.meta.subTitle === 'Laidan' ? '/favicon.ico' : '/favicon2.ico'
            if (to.meta.subTitle === 'Laidan') {
                favicon.href = '/favicon.ico'
            } else if (to.meta.subTitle === 'Joinku') {
                favicon.href = '/favicon2.ico'
            } else {
                favicon.href = '/favicon3.ico'
            }
            document.head.appendChild(favicon)
        }
    }
    next()
})

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
}).$mount("#app");
